// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__3joAB","content":"checkbox_content__oGSiL","panel-extra":"checkbox_panel-extra__2L7Zu"};